import { Flex, LocalVideo, RemoteVideo, Text } from '../2022-component-library';
import { MainPanel } from '.';
import { Icon } from '../component-library';
import { useVideo } from '../context/videoContext';
import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { useMediaQuery } from '../helpers/useMediaQuery';
import { calibrationConstants } from '../helpers/calibration-constants';

const VideoContainer = styled(Flex)`
  width: clamp(180px, 85%, 700px);
  aspect-ratio: 1.5;
  border-radius: ${calibrationConstants.VIDEO_BORDER_RADIUS}px;
  box-shadow: 0px 11px 22px #b9d5d5;
  position: relative;
  overflow: hidden;
`;

const VideoRefreshOverlay = styled(Flex)`
  background-color: rgba(0, 0, 0, 0.2);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 10px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }

  & svg {
    display: block !important;
  }
`;

const VideoConsultation = ({ userInfo }) => {
  const [userRole, setUserRole] = useState('');
  const [remoteUserName, setRemoteUserName] = useState('');
  const { reconnect } = useVideo();
  const { patient_full_name, optician_full_name, full_name, role } = userInfo;
  const smallScreen = useMediaQuery('(max-width: 650px)');

  const refreshVideo = () => reconnect();

  useEffect(() => {
    const titleCaseRole = role.charAt(0).toUpperCase() + role.slice(1);
    setUserRole(titleCaseRole);

    if (role === 'patient') {
      setRemoteUserName(optician_full_name);
    } else setRemoteUserName(patient_full_name);
  }, [role, optician_full_name, patient_full_name]);

  return (
    <MainPanel title='IbisEngage - Appointment' width='90vw' mt='20px' maxWidth='1350px'>
      <Flex width='100%' justifyContent='center' gap={smallScreen ? '1rem' : '3rem'} padding='1.5rem 0 2.5rem 0'>
        <Flex column centered width='50%'>
          <Flex marginBottom='1rem' fontSize={smallScreen ? '0.825rem' : '1rem'}>
            <Text color='black' fontWeight='bold'>
              {`${userRole}:\u00a0`}
            </Text>
            <Text>{full_name}</Text>
          </Flex>
          <VideoContainer>
            <VideoRefreshOverlay onClick={() => refreshVideo()}>
              <Icon icon='loop2' size={15} color='white' />
            </VideoRefreshOverlay>
            <LocalVideo controls />
          </VideoContainer>
        </Flex>
        <Flex column centered width='50%'>
          <Flex marginBottom='1rem' fontSize={smallScreen ? '0.825rem' : '1rem'}>
            <Text color='black' fontWeight='bold'>
              {`${userRole === 'Patient' ? 'Clinician' : 'Patient'}:\u00a0`}
            </Text>
            <Text>{remoteUserName}</Text>
          </Flex>
          <VideoContainer>
            <RemoteVideo />
          </VideoContainer>
        </Flex>
      </Flex>
    </MainPanel>
  );
};

export default VideoConsultation;
